var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-5",attrs:{"outlined":"","min-height":"250"}},[_c('v-card-text',[_c('v-row',{attrs:{"no-gutters":""}},[_c('NameField',{attrs:{"item":_vm.item,"md":"2"}}),_c('StatisticField',{attrs:{"item":_vm.item,"md":"6"}}),_c('AdditionalField',{attrs:{"item":_vm.item,"md":"3"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }